import React from 'react';

import { useParams } from 'react-router-dom';
import { useGetOccurrenceByIdQuery } from 'src/redux/services/centralApi';
import DashboardTemplate from 'src/templates/DashboardTemplate';
import dayjs from 'dayjs';
import locale from 'dayjs/locale/pt-br';
import OccurrenceDescription from 'src/pages/occurrences/OccurrenceDetails/components/OccurrenceDescription';
import OccurrenceTable from 'src/pages/occurrences/OccurrenceDetails/components/OccurrenceTable';

dayjs.locale(locale);

export default function OccurrenceDetais() {
	const { occurrence_id, } = useParams();

	const { data, isLoading, } = useGetOccurrenceByIdQuery({ id: occurrence_id as string, });

	return (
		<DashboardTemplate pageTitle='Dados da ocorrência'>
			<OccurrenceDescription data={data} />
			<hr />
			{
				data &&
				<OccurrenceTable
					occurrence_data={data.ocurrence_data}
					loading={isLoading}
				/>
			}
		</DashboardTemplate>
	);
}
